import { Component, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { SignSignatory } from '@shared/models/signrequest/sign.signatory';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EmailInputComponent } from '../../email-input/email-input.component';
import { SettingsService } from '@services/settings/settings.service';

@Component({
    selector: 'app-sr-submitter',
    templateUrl: './sr-submitter.component.html',
    styleUrls: ['./sr-submitter.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TranslateModule, EmailInputComponent]
})
export class SrSubmitterComponent implements OnInit, OnDestroy {
    @Input() submitter!: Partial<SignSignatory>;
    @Output() updateSubmitter = new Subject();
    readonly form: UntypedFormGroup;
    private subscription: Subscription = new Subscription();

    private readonly settingsService: SettingsService = inject(SettingsService);
    private readonly formbuilder: UntypedFormBuilder = inject(UntypedFormBuilder);

    constructor(
    ) {
        this.form = this.formbuilder.group({
            name: [null, [Validators.required, Validators.maxLength(50)]],
            email: [null, [Validators.required, Validators.email, Validators.maxLength(100)]]
        });

        this.subscription.add(this.form.valueChanges.pipe(
            distinctUntilChanged(),
            debounceTime(300)
        ).subscribe(res => {
            this.submitter.name = res.name;
            this.submitter.email = res.email;
            this.updateSubmitter.next(this.submitter);
        }));
    }

    get emailControl() {
        return this.form.get('email');
    }

    ngOnInit() {
        this.form.patchValue(this.submitter);

        const settings = this.settingsService.settings;


        if (settings?.defaultSubmitter || settings?.defaultSubmitterEmail) {
            this.form.patchValue({
                name: (settings.defaultSubmitter && settings.defaultSubmitter.trim()) ? settings.defaultSubmitter : this.submitter.name,
                email: (settings.defaultSubmitterEmail && settings.defaultSubmitterEmail.trim())? settings.defaultSubmitterEmail : this.submitter.email
            });
        } else {
            this.form.patchValue(this.submitter);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    patchEmail(email: string) {
        this.emailControl?.patchValue(email);
    }

    emailErrors(errors: ValidationErrors) {
        if (errors) {
            this.emailControl?.setErrors(errors);
        }
    }
}
